import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sjk",
  "use": "sjk-usage",
  "viewBox": "0 0 47.836 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 47.836 48\" id=\"sjk\"><g transform=\"translate(-1436.082 -3045)\"><g transform=\"translate(9.082 107)\"><path d=\"M25,48A23.957,23.957,0,0,1,1.081,26H5.1a20,20,0,0,0,39.8,0h4.017A24,24,0,0,1,25,48ZM5.1,22H1.082A24.005,24.005,0,0,1,25,0,23.957,23.957,0,0,1,48.918,22H44.9A20,20,0,0,0,5.1,22Z\" transform=\"translate(1425.918 2938)\" /><rect width=\"8\" height=\"8\" transform=\"translate(1447 2958)\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol